export default __webpack_public_path__ + "99bd1c6a6f297964eae79c0f9d3475fe.svg";